import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-detail-card',
  standalone: true,
  imports: [MatIconModule],
  host: { '[attr.title]': 'null', '[class.detail-card--static]': '!scrollable' },
  templateUrl: './detail-card.component.html',
  styleUrl: './detail-card.component.scss'
})
export class DetailCardComponent {
  @Input({ required: true }) title = '';
  @Input() icon = '';
  @Input() subtitle = '';
  @Input() scrollable = true;
  @Input() isEmpty = false;
  @Input() emptyMessage = 'Sin datos para mostrar.';
  @Input() emptyIcon = '';
  @Input() emptyDescription = '';
}
